<template lang="pug">
main(v-if="Show")
  parallax-inview
    animation-fade-in-up
      .page-top-image
        .image
          img(src="../assets/image01.jpg")
        .text
          h1.title Voice
            span.title-caption お客さまの声
  parallax-inview
    animation-fade-in-up
      .page-description
        p 当店をご利用した後に、<br>お客さまから頂いた声を一部ご紹介いたします。

  parallax-inview
    animation-fade-in-up
      section.section.is-first(:style="'background-position: ' + ImageScroll(0)")
        h2.title.voice-title 髪質改善
        p.text せっかくのお出かけなのに、どうやってもまとまらない髪・・・<br>そんな時に友達から勧められ、髪質改善と出会いました。すると周りから「最近綺麗になったよね」「どこの美容院行ってるの？」と言われるようになりました！<br>髪の扱いも楽になり、どこへ行っても自分に自信をもって楽しめるようになりました。

  parallax-inview
    animation-fade-in-up
      section.section.is-second(:style="'background-position: ' + ImageScroll(1)")
        h2.title.voice-title ミディアム・ロング
        p.text 髪は長いままがいいんだけど、ちょっと雰囲気も変えたい・・・<br>長さは残しながら、前髪を作る提案や顔周りに段を入れる提案をしてくれました。<br>長さを切ってないのに友達から「なんか雰囲気変わったね！」「可愛くなった！」と言ってもらえ、飽きずにロングヘアを楽しめてます！<br>髪質の変化に伴い、本当に自分にあっているヘアケアがわからない・・・<br>ずっと気になっていたシャンプー専門店へ行ってみました。<br>すると自分の今の悩みと髪質に合わせて、数種類のシャンプーをお勧めしてくれて、香りも試香させてくれました。<br>シャンプーを変えた、たったそれだけで周りからは「いつまでも若々しいよね」と言われ日々使うものの大切さを実感しました。

  parallax-inview
    animation-fade-in-up
      section.section.is-third(:style="'background-position: ' + ImageScroll(2)")
        h2.title.voice-title ヘッドスパ
        p.text せっかくの贅沢なんだから絶対満足できるところがいい！<br>これまで満足できなかったヘッドスパだけど、とっても丁寧にしてくれて<br>美容師さんも「ここはスパだけのお客様も多いです」と言っていたのが納得でした。<br>アロマも選べ、使っているクリームも高級トリートメントを使っているらしく髪もサラサラになりました。<br>大型店のガヤガヤした雰囲気や、施術の度に人が変わっちゃうのが苦手でした。<br>ここは、最初から最後まで一人の美容師さんが担当して下さって、とっても安心できました。<br>美容師さんがおっしゃっていた「ひとりひとりにしっかり向き合いたい」と言う気持ちがとても伝わり、毎回安心して通うことが出来てます！

</template>

<script>
import ParallaxInview from './parallax/ParallaxInview.vue'
import AnimationFadeInUp from './effect/animation/AnimationFadeInUp.vue'

export default {
  head: {
    title() {
      return {
        inner: 'Shampoo Selection',
        separator: '|',
        complement: 'シャンプーセレクション 蔵前美容室 | Voice',
      }
    },
    link: [
      { rel: 'preconnect', href: 'https://fonts.gstatic.com' },
      { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css2?family=Noto+Serif+JP:wght@200;300;400;500;600;700;900&display=swap' }
    ]
  },
  props: ['loadingEnd', 'scrollY'],
  components: {
    ParallaxInview,
    AnimationFadeInUp
  },
  computed: {
    Show:{
      get: function() {
        return this.loadingEnd
      }
    },
    ScrollY: {
      get: function() {
        return this.scrollY
      }
    }
  },
  methods:{
    ImageScroll: function(index) {
      let scroll = '';
      if (index === 0) {
        scroll = '-91px ' + (-100 + this.ScrollY / 4.5)
      } else if (index === 1) {
        scroll = '91px ' + (-200 + this.ScrollY / 4.5)
      } else if (index === 2) {
        scroll = '-91px ' + (-300 + this.ScrollY / 4.5)
      }
      return scroll + 'px'
    }
  }
}
</script>

<style lang="scss" scoped>
.page-top-image {
  > .image {
    transform: scale(1);
  }
}

.section {
  position: relative;
  padding: 25px 25px 45px;
  margin-bottom: 80px;
  overflow: hidden;
  &::before {
    content: '';
    height: 100%;
    background: rgba(0,0,0,0.8);
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  &.is-first {
    background: url(../assets/image_shampoo_01.jpg) no-repeat;
    background-position: -71px -100px;
    background-size: cover;
  }
  &.is-second {
    background: url(../assets/image14.jpg) no-repeat;
    background-position: 71px -100px;
    background-size: cover;
  }
  &.is-third {
    background: url(../assets/image12.jpg) no-repeat;
    background-position: -71px -100px;
    background-size: cover;
  }

  .text {
    text-align: left;
  }
}

.voice-title {
  text-align: left;
}

</style>



// WEBPACK FOOTER //
// src/components/Voice.vue